module.exports = __webpack_public_path__ + "static/media/ru.bc019575.png";